import AxImage from './AxImage';

class AxImageController {
  constructor() {
    this.list = document.querySelectorAll('.wp-ax-image');
    
    this.list.forEach((item) => {
      const image = item.querySelector('img');
      if (image.complete && image.naturalHeight !== 0) {
        this.initializeAxImage(item, image);
      } else {
        image.addEventListener('load', () => {
          this.initializeAxImage(item, image);
        });
      }
    });
  }

  initializeAxImage(item, image) {
    image.classList.add('is-loaded');
    new AxImage(item);
  }
  
}

new AxImageController();